import { FormControlLabel, Checkbox } from "@mui/material";
import React from "react";
import { Box } from "@mui/material";

export const ActiveFilterControls = (props: {
  showActiveChecked: boolean;
  showArchivedChecked: boolean;
  onChangeShowActive: (checked: boolean) => void;
  onChangeShowArchived: (checked: boolean) => void;
}) => {
  return (
    <Box sx={{ display: "inline", ml: 2 }}>
      <FormControlLabel
        sx={{
          border: "1px solid",
          borderColor: "primary.dark",
          borderRadius: "4px",
          pr: 1,
          ml: 1,
          mb: 1,
        }}
        control={
          <Checkbox
            name="showActive"
            checked={props.showActiveChecked}
            onChange={(event, checked) => props.onChangeShowActive(checked)}
            color="primary"
          />
        }
        label="Show Active"
      />

      <FormControlLabel
        sx={{
          border: "1px solid",
          borderColor: "primary.dark",
          borderRadius: "4px",
          pr: 1,
          ml: 1,
          mb: 1,
        }}
        control={
          <Checkbox
            checked={props.showArchivedChecked}
            onChange={(event, checked) => props.onChangeShowArchived(checked)}
            name="showArchived"
            color="primary"
          />
        }
        label="Show Archived"
      />
    </Box>
  );
};
